import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const slide = trigger('slide', [
  state('void', style({ opacity: 0, top: -20 })),
  state('enter', style({ opacity: 1, top: 0 })),
  transition('* <=> *', animate('200ms')),
]);
